import React from 'react';
import { Button, Space, Tooltip, Typography, theme } from 'antd';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import { useIntl } from 'react-intl';

interface NightsStepperProps {
  value: number;
  min?: number;
  max?: number;
  onDecrease: () => void;
  onIncrease: () => void;
  disabled?: boolean;
}

const NightsStepper: React.FC<NightsStepperProps> = ({
  value,
  min = 1,
  max = 30,
  onDecrease,
  onIncrease,
  disabled = false,
}) => {
  const intl = useIntl();
  const { token } = theme.useToken();
  const decreaseDisabled = disabled || value <= min;
  const increaseDisabled = disabled || value >= max;

  return (
    <div
      style={{
        width: '100%',
        border: `1px solid ${token.colorBorder}`,
        borderRadius: token.borderRadius,
        height: 40,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 8px',
        background: token.colorBgContainer,
      }}
    >
      <Tooltip
        title={intl.formatMessage({
          id: 'booking.nights.decrease',
          defaultMessage: 'Decrease nights',
        })}
      >
        <Button
          type="text"
          icon={<MinusOutlined />}
          onClick={onDecrease}
          disabled={decreaseDisabled}
          style={{
            color: decreaseDisabled ? token.colorTextDisabled : token.colorText,
          }}
        />
      </Tooltip>

      <Space orientation="vertical" size={0} style={{ alignItems: 'center' }}>
        <Typography.Text strong style={{ lineHeight: 1.2, color: token.colorText }}>
          {intl.formatMessage(
            {
              id: 'booking.nights.count',
              defaultMessage: '{count, plural, one {# night} other {# nights}}',
            },
            { count: value }
          )}
        </Typography.Text>
      </Space>

      <Tooltip
        title={intl.formatMessage({
          id: 'booking.nights.increase',
          defaultMessage: 'Increase nights',
        })}
      >
        <Button
          type="text"
          icon={<PlusOutlined />}
          onClick={onIncrease}
          disabled={increaseDisabled}
          style={{
            color: increaseDisabled ? token.colorTextDisabled : token.colorText,
          }}
        />
      </Tooltip>
    </div>
  );
};

export default NightsStepper;
